// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1mKgm","upload":"Small_upload__14Mjm","imageWrap":"Small_imageWrap__3ZvLO","removeBtn":"Small_removeBtn__3nN2g"};